// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__37SIp","label":"Labeled_label__b72PA","divider":"Labeled_divider__3EcZt"};